var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:['btn', `btn--${_vm.color}`],attrs:{"disabled":_vm.disabled || _vm.loading,"outline":_vm.outline,"to":_vm.to,"type":_vm.type,"name":_vm.name},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.loading)?_vm._t("default"):_vm._e(),(_vm.loading)?_c('loading-dots'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }